import useTranslation from 'next-translate/useTranslation';
import { useToastStore } from '@/stores/useToastStore';

export interface ToastInterface {
  text: string;
  status: 'danger' | 'success' | 'warning';
  fields?: string[] | null | undefined;
  time?: number | undefined | null;
}

function useToast() {
  const toastStore = useToastStore((state) => ({
    openToast: state.openToast,
    closeToast: state.closeToast,
  }));

  const { t } = useTranslation();

  /**
   * Open toast
   * @param param
   * @returns
   */
  const openToast = ({ text = '', status = 'danger', fields = [], time = 5000 }: ToastInterface) =>
    toastStore.openToast({ text, status, fields, time });

  /**
   * Close Toast
   * @returns
   */
  const closeToast = () => toastStore.closeToast();

  /**
   * Helper error
   * @param error
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function helperErrorToast(error: any) {
    if (error?.data.message) openToast({ text: error.data.message, status: 'danger' });
    else openToast({ text: t('validations:general'), status: 'danger' });
  }

  return { openToast, closeToast, helperErrorToast };
}

export default useToast;
